import React from "react";
import Layout from "../components/Common/Layout";
import PendingTraining from "../components/PendingTraning/PendingTraining";

const PendingTrainingPage = () => {
  return (
    <Layout>
      <PendingTraining />
    </Layout>
  );
};

export default PendingTrainingPage; 